export class NFTRequiredError extends Error {
  constructor(message: string | any) {
    super(message);
  }
}
